module.exports = __webpack_public_path__ + "static/media/cc-bobina4.b6132401.jpg";